// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const amberRock = defineModel({
  id: "amber-rock",
  batchId: "future",
  name: "Amber rock",
  tags: ["scenery","amber","rock","low-poly","age-of-mcp","future"],
  summary: "Amber embedded in rock. A prized gem for ornament and trade.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.44,
  parts: () => [
      { geometry: new THREE.IcosahedronGeometry(0.3, 0), color: "#5a4128", position: [0, 0.22, 0], rotation: [0.05, 0.4, 0.06], scale: [1.1, 0.95, 1.05] },
      { geometry: new THREE.IcosahedronGeometry(0.18, 0), color: "#674c30", position: [0.22, 0.14, 0.08], rotation: [0.1, 1.2, 0], scale: [1, 0.9, 0.95] },
      { geometry: new THREE.CylinderGeometry(0.05, 0.09, 0.24, 6), color: "#4a341f", position: [-0.2, 0.08, 0.12], rotation: [0.5, 0.3, 0.3] },
      { geometry: new THREE.CylinderGeometry(0.04, 0.08, 0.2, 6), color: "#5a4128", position: [0.18, 0.07, -0.16], rotation: [-0.4, 0.8, 0.4] },
      { geometry: new THREE.CylinderGeometry(0.04, 0.07, 0.18, 6), color: "#674c30", position: [-0.04, 0.06, -0.22], rotation: [0.5, 0.2, -0.2] },
      { geometry: new THREE.IcosahedronGeometry(0.1, 0), color: "#e0a83a", position: [0.06, 0.3, 0.18], rotation: [0.2, 0.5, 0.1], scale: [1, 0.95, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#f2c45e", position: [-0.14, 0.26, 0.14], rotation: [0.3, 1, 0.2] },
      { geometry: new THREE.IcosahedronGeometry(0.07, 0), color: "#c78a26", position: [0.16, 0.22, 0.14], rotation: [0.1, 1.6, 0.2] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#e0a83a", position: [-0.02, 0.4, 0.04], rotation: [0.2, 0.8, 0.1] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#f2c45e", position: [0.1, 0.36, -0.08], rotation: [0.2, 0.4, 0.2] },
      { geometry: new THREE.TetrahedronGeometry(0.06, 0), color: "#c78a26", position: [0.18, 0.04, 0.13], rotation: [0.3, 0.8, 0.2] },
      { geometry: new THREE.IcosahedronGeometry(0.045, 0), color: "#e0a83a", position: [-0.18, 0.04, -0.08], rotation: [0.2, 1, 0.3], scale: [1.1, 0.7, 1] },
      { geometry: new THREE.TetrahedronGeometry(0.07, 0), color: "#4a341f", position: [0.04, 0.04, -0.3], rotation: [0.3, 0.4, 0.3] },
    ],
  animations: [],
});
